// https://en.wikipedia.org/wiki/List_of_XML_and_HTML_character_entity_references
export const ENDASH = String.fromCharCode(8211);
export const HELLIP = String.fromCharCode(8230);
export const NBSP = String.fromCharCode(160);
export const THINSP = String.fromCharCode(8201); // thin space
export const HAIRSP = String.fromCharCode(8202); // hair space
export const ZEROWIDTHSP = String.fromCharCode(8203); // zero width space
